<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <!-- Dynamic Parent -->
      <router-link v-if="fromNotifications" :to="{ name: 'ViewPendingNotifications', query: { entityType: route.query.entityType, statusInd: route.query.statusInd } }"
        class="mb-0 main-identifier fw-semibold text-decoration-none">
        Notifications
      </router-link>

      <router-link v-else :to="{ name: 'ViewAppraisals' }" class="mb-0 main-identifier fw-semibold text-decoration-none">
        Appraisals
      </router-link>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">View Appraisal</p>
    </div>

    <div class="d-flex justify-content-center mb-5">

      <div class="form-outer">
        <form @submit.prevent="step === totalSteps ? handleSubmit() : handleNext()">
          <div class="crud-form position-relative">

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Appraisal</h1>
                <button type="button" class="btn btn-primary btn-sm view-memo-btn" @click="openMemoPreview"
                  :disabled="!form.memoFileNumber" title="View Memo Details">
                  <span class="material-symbols-outlined align-middle me-1" style="font-size: 1.1rem;">description</span>
                  View Memo
                </button>
              </div>

              <div class="form-body-area position-relative">
                <div v-if="!isDataLoaded" class="loading-overlay text-center">
                  <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
                  <p class="mt-2 mb-0 text-muted">Loading appraisal details...</p>
                </div>

              <div v-if="isDataLoaded" class="form-body mt-2 mb-3" style="padding: 0 20px;">
                <div v-if="step === 1">

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center">
                      <label for="year"
                        class="form-label">Appraisal Initiated Date</label>
                      </div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" :value="formatDate(form.appraisalInitiatedDate)"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Originating MDA</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.originatingMda"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Approval Authority</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.approvalAuthority"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Organizational Code</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.orgCode" placeholder=""
                        readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Nature of Expenditure</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.natureOfExpenditure"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Purpose of Request</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.purposeOfRequest"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Budget Year</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.budgetYear" placeholder=""
                        readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Quarter</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" :value="'Q' + form.quarter" placeholder=""
                        readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Approved Budget Amount</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input"
                        :value="'₦' + formatCurrency(form.amountApproved || 0)" placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Amount Released To Date</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input"
                        :value="'₦' + formatCurrency(form.amtReleasedToDate || 0)" placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Balance</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input"
                        :value="'₦' + formatCurrency(form.balance || 0)" placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Performance</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" :value="Number(form.performance || 0).toFixed(2) + '%'"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="table-responsive mt-4">
                    <table class="table table-bordered appraisal-view text-center align-middle">
                      <thead class="table-light">
                        <tr>
                          <th>Eco Code</th>
                          <th>Title</th>
                          <th>Amount Budgeted</th>
                          <th>Amount Released</th>
                          <th>Balance</th>
                          <th>Amount Required</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in economicItems" :key="index" :class="index % 2 === 0 ? 'row-even' : 'row-odd'">
                          <td>
                            {{ item.ecoCode }}
                          </td>
                          <td>
                            {{ item.title }}
                          </td>
                          <td>
                            ₦{{ formatCurrency(item.amountBudgeted || 0) }}
                          </td>
                          <td>
                            ₦{{ formatCurrency(item.amountReleased || 0) }}
                          </td>
                          <td>
                            ₦{{ formatCurrency(item.balance || 0) }}
                          </td>
                          <!-- <td>
                                          {{ item.performance }}%
                                        </td> -->
                          <td>
                            ₦{{ formatCurrency(item.amountRequired || 0) }}
                          </td>
                          <!-- <td>
                                          <input
                                            type="number"
                                            min="0"
                                            class="form-control form-control-sm"
                                            v-model.number="item.amountRequired"
                                            @input="validateBudgetStep"
                                          />
                                          {{ item.amountRequired }}
                                        </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <!-- <div class="mt-3 text-end">
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="addEconomicItem">
                                      <span class="iconify" data-icon="mdi:plus"></span> Add More
                                    </button>
                                  </div> -->
                  </div>

                  <div class="row mb-3 budget-item-wrapper justify-content-center step-3" style="margin-top: 15px;">

                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label for="year" class="form-label fw-bold fixed-label">Quarterly Authorization Limit
                          Number</label>
                        <input type="text" class="form-control view-only-input text-center"
                          v-model="form.noOfAuthIssuedInQtr" placeholder="" readonly>
                      </div>
                    </div>

                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label for="year" class="form-label fw-bold fixed-label">Number Already Approved In
                          Quarter</label>
                        <input type="text" class="form-control view-only-input text-center"
                          v-model="form.noOfAppLimitPerQtr" placeholder="" readonly>
                      </div>
                    </div>

                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label for="year" class="form-label fw-bold fixed-label">Quarterly Authorized Limit
                          Balance</label>
                        <input type="text" class="form-control view-only-input text-center"
                          v-model="form.noOfAuthLeftInQtr" placeholder="" readonly>
                      </div>
                    </div>



                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label for="year" class="form-label fw-bold fixed-label">Quarterly Authorized Amount</label>
                        <input type="text" class="form-control view-only-input text-center"
                          :value="'₦' + formatCurrency(form.qtrAuthLimitAmt || 0)" placeholder="" readonly>
                      </div>
                    </div>

                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label for="year" class="form-label fw-bold fixed-label">Approved Capital Amount</label>
                        <input type="text" class="form-control view-only-input text-center"
                          :value="'₦' + formatCurrency(form.approvedCapitalAmount || 0)" placeholder=""
                          readonly>
                      </div>
                    </div>

                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label for="year" class="form-label fw-bold fixed-label">Approved Recurrent Amount</label>
                        <input type="text" class="form-control view-only-input text-center"
                          :value="'₦' + formatCurrency(form.approvedRecurrentAmount || 0)" placeholder=""
                          readonly>
                      </div>
                    </div>

                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label for="year" class="form-label fw-bold fixed-label">Approval Balance</label>
                        <input type="text" class="form-control view-only-input text-center"
                          :value="'₦' + formatCurrency(form.approvalBalance || 0)" placeholder="" readonly>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Evaluation Remark</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.evalRemarks" placeholder=""
                        readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Total Amount Recommended</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input"
                        :value="'₦' + formatCurrency(form.amtRecommended || 0)" placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Sectoral Head Remark</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.sectoralHeadRemarks"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Director of Budget Remark</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.dobRemarks" placeholder=""
                        readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Permanent Secretary Remark</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.permSecRemarks" placeholder=""
                        readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group" v-if="form.commissionerRemarks">
                    <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Commissioner for Budget and Planning Remark</label></div>
                    <div class="col-md-7 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.commissionerRemarks"
                        placeholder="" readonly>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Appraisal Status</label></div>
                      <div class="col-md-7 input-right">
                        <div class="col-md-12 input-right">
                          <input type="text" class="form-control form-view-only-input"
                            v-model="appraisalStatus" placeholder="" readonly>
                        </div>
                      </div>
                    </div>
                </div>

                <div class="mt-4">
                  <div class="d-flex justify-content-end gap-3 warrant-download-btn-wrapper">
                    <button v-if="rolesLoaded && hasAccess(['qssu']) && appraisalStatus === 'Pending'" type="button"
                      class="btn btn-outline-danger recall-btn-app" @click="recallAppraisal"
                      :disabled="loadingRecall" aria-live="polite"
                      :aria-label="loadingRecall ? 'Recalling...' : 'Recall Appraisal'">
                      <span v-if="loadingRecall" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                      {{ loadingRecall ? 'Recalling...' : 'Recall Appraisal' }}
                    </button>
                    <button v-if="appraisalStatus === 'Completed'" type="button"
                      class="btn btn-outline-primary download-btn-app" @click="downloadWarrant"
                      :disabled="loadingDownload" aria-live="polite"
                      :aria-label="loadingDownload ? 'Downloading...' : 'Download Warrant'">
                      <span v-if="loadingDownload" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                      {{ loadingDownload ? 'Downloading...' : 'Download Warrant' }}
                    </button>
                    <!-- <button type="button" class="btn btn-secondary back-btn" @click="handleBack">
                                  <span class="iconify" data-icon="formkit:arrowleft" style="font-size: 1.2em;"></span>
                                  Previous
                                </button> -->
                    <!-- <button type="button" class="btn btn-primary submit-btn" @click="downloadWarrant">
                      Download
                    </button> -->
                  </div>
                </div>
              </div>
              </div>

            </div>


          </div>
        </form>
      </div>
    </div>

    <div v-if="showMemoPreview" class="memo-preview-overlay" @click="closeMemoPreview">
      <div class="memo-preview-modal" @click.stop>
        <div class="memo-preview-header">
          <h5 class="mb-0">Memo Details</h5>
          <button type="button" class="btn-close" aria-label="Close" @click="closeMemoPreview"></button>
        </div>

        <div class="memo-preview-body">
          <div v-if="loadingMemoPreview" class="preview-grid mb-3">
            <div class="preview-item" v-for="n in 5" :key="n">
              <small>&nbsp;</small>
              <p class="mb-0 memo-skeleton-bar"></p>
            </div>
          </div>

          <p v-else-if="memoPreviewError" class="text-danger mb-0">{{ memoPreviewError }}</p>

          <div v-else class="preview-grid mb-3">
            <div class="preview-item">
              <small>File Title</small>
              <p class="mb-0">{{ memoPreviewData?.fileTitle || 'N/A' }}</p>
            </div>
            <div class="preview-item">
              <small>File Number</small>
              <p class="mb-0">{{ memoPreviewData?.fileNumber || 'N/A' }}</p>
            </div>
            <div class="preview-item">
              <small>Originating MDA</small>
              <p class="mb-0">{{ memoPreviewData?.originatingMda || 'N/A' }}</p>
            </div>
            <div class="preview-item">
              <small>Amount Approved</small>
              <p class="mb-0">₦{{ formatCurrency(memoPreviewData?.amountApproved || 0) }}</p>
            </div>
            <div class="preview-item">
              <small>Created Date</small>
              <p class="mb-0">{{ formatMemoDate(memoPreviewData?.createdDate) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, reactive, onMounted, computed, watch } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/stores/user';
// import { saveAs } from 'file-saver'

// const router = useRouter();


const root_api_url = process.env.VUE_APP_API_ROOT_URL
const totalSteps = 3
const step = ref(1)
const fromNotifications = computed(() => route.query.from === 'ViewPendingNotifications'  && route.query.entityType && route.query.statusInd)
const route = useRoute()
const id = route.params.id
const loadingDownload = ref(false)
const loadingRecall = ref(false)
const isDataLoaded = ref(false)
const isApproved = ref(false)
const isRejected = ref(false)
const isReturned = ref(false)
const isRecalled = ref(false)

const userStore = useUserStore()
const rolesLoaded = ref(false)

const hasAccess = (required) => {
  const profileRoles = userStore.profile?.role || {};
  if (!required || required.length === 0) return true;
  return required.some(role => !!profileRoles[role]);
}

// Reactive form data
const form = reactive({
  id: '',
  originatingMda: '',
  approvalAuthority: '',
  natureOfExpenditure: '',
  amountApproved: '',
  purposeOfRequest: '',
  approvedBudgetAmount: '',
  amtReleasedToDate: '',
  balance: '',
  performance: '',
  quarter: '',
  budgetYear: '',
  appraisalInitiatedDate: '',
  noOfAppLimitPerQtr: '',
  noOfAuthIssuedInQtr: '',
  noOfAuthLeftInQtr: '',
  qtrAuthLimitAmt: '',
  approvedRecurrentAmount: '',
  approvedCapitalAmount: '',
  approvalBalance: '',
  evalRemarks: '',
  amtRecommended: '',
  sectoralHeadRemarks: '',
  dobRemarks: '',
  commissionerRemarks: '',
  orgCode: '',
  permSecRemarks: '',
  memoFileNumber: '',
})

function formatCurrency(val) {
  if (val === '' || val === null || val === undefined) return '';
  const num = Number(val);
  if (isNaN(num)) return '';
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const formatDate = (dateString) => {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}


const showMemoPreview = ref(false)
const memoPreviewData = ref(null)
const loadingMemoPreview = ref(false)
const memoPreviewError = ref('')

const formatMemoDate = (dateValue) => {
  if (!dateValue) return 'N/A'
  const date = new Date(dateValue)
  if (Number.isNaN(date.getTime())) return 'N/A'
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const openMemoPreview = async () => {
  const fileNumber = form.memoFileNumber
  if (!fileNumber) return

  showMemoPreview.value = true
  loadingMemoPreview.value = true
  memoPreviewError.value = ''
  memoPreviewData.value = null

  const token = Cookies.get('auth_token')
  try {
    const { data } = await axios.post(`${root_api_url}/appraisal/memo/number`, { memoFileNumber: fileNumber }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    if (data?.errorMessage) {
      throw new Error(data.errorMessage)
    }

    memoPreviewData.value = data
  } catch (error) {
    console.error('Error fetching memo details:', error)
    memoPreviewError.value = error?.response?.data?.errorMessage || error?.response?.data?.error || error?.response?.data?.message || 'Unable to load memo details. Please try again.'
  } finally {
    loadingMemoPreview.value = false
  }
}

const closeMemoPreview = () => {
  showMemoPreview.value = false
}

const economicItems = ref([])


const appraisalStatus = computed(() => {
  // compute the status
  let status

  if (isApproved.value) {
    status = 'Completed'
  } else if (isRecalled.value) {
    status = 'Recalled'
  } else if (isRejected.value) {
    status = 'Rejected'
  } else if (isReturned.value) {
    status = 'Returned'
  } else {
    status = 'Pending'
  }
  // log the raw values and the result
  console.log(
    '🧪 appraisalStatus computed:',
    {
      dobRemarks: form.dobRemarks,
      sectoralHeadRemarks: form.sectoralHeadRemarks,
      commissionerRemarks: form.commissionerRemarks,
      permSecRemarks: form.permSecRemarks,
      status, appraisalStatus
    }
  );

  return status;
});

const fetchAppraisal = async () => {
  const token = Cookies.get('auth_token')
  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/appraisal/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })



    // console.log(data);
    form.originatingMda = data.originatingMda;
    form.approvalAuthority = data.approvalAuthority;
    if (data.natureOfExpenditure == 2) {
      form.natureOfExpenditure = 'Recurrent';
    } else if (data.natureOfExpenditure == 3) {
      form.natureOfExpenditure = 'Capital';
    } else if (data.natureOfExpenditure == 4) {
        form.natureOfExpenditure = 'Hybrid';
    }
    form.amountApproved = data.amountApproved;
    form.purposeOfRequest = data.purposeOfRequest;
    form.approvedBudgetAmount = data.approvedBudgetAmount;
    form.amtReleasedToDate = data.amtReleasedToDate;
    form.balance = data.balance;
    form.performance = data.performance;
    form.quarter = data.quarter;
    form.budgetYear = data.budgetYear;
    form.appraisalInitiatedDate = data.appraisalInitiatedDate;
    form.noOfAppLimitPerQtr = data.noOfAppLimitPerQtr;
    form.noOfAuthIssuedInQtr = data.noOfAuthIssuedInQtr;
    form.noOfAuthLeftInQtr = data.noOfAuthLeftInQtr;
    form.qtrAuthLimitAmt = data.qtrAuthLimitAmt;
    form.approvedRecurrentAmount = data.approvedRecurrentAmount;
    form.approvedCapitalAmount = data.approvedCapitalAmount;
    form.approvalBalance = data.approvalBalance;
    form.evalRemarks = data.evalRemarks;
    form.amtRecommended = data.amtRecommended;
    form.sectoralHeadRemarks = data.sectoralHeadRemarks;
    form.dobRemarks = data.dobRemarks;
    form.permSecRemarks = data.permSecRemarks;
    form.commissionerRemarks = data.commissionerRemarks;
    form.orgCode = data.orgCode;
    form.memoFileNumber = data.memoFileNumber;

    economicItems.value = (data.appraisalEconomicItems || []).map(dto => ({
      id: dto.id,
      //ecoCode: dto.economicLineItemDto.economicCode,
      ecoCode: dto.ecoCode,
      title: dto.title,
      mdaLineItemBudgetId: dto.mdaLineItemBudgetId,
      amountBudgeted: dto.amountBudgeted,
      amountReleased: dto.amountReleased,
      balance: dto.balance,
      amountRequired: dto.amountRequired,
      year: dto.performance,
      quarter: dto.performance
    }));

    isApproved.value = Boolean(data.warrantApprovedInd);
    isReturned.value = Boolean(data.returnedAppraisalInd);
    isRejected.value = Boolean(data.appraisalRejectedInd);
    isRecalled.value = Boolean(data.recalledInd);

    isDataLoaded.value = true;

  } catch (err) {
    console.error('Error loading ECO items:', err)
    isDataLoaded.value = true;
    const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>${err?.response?.data?.errorMessage || err?.response?.data?.error || err?.response?.data?.message || 'Failed to load appraisal details. Please try again.'}</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
  }
}

const downloadWarrant = async () => {
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`
  loadingDownload.value = true
  const token = Cookies.get('auth_token')

  try {
    const response = await axios.get(
      `${root_api_url}/appraisal/warrant/pdf/1/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob'
      }
    )

    let downloadName = 'warrant.pdf' // default filename

    const disposition = response.headers['content-disposition']
    console.log('Content-Disposition header:', response.headers)

    if (disposition && disposition.includes('filename=')) {
      downloadName = disposition
        .split('filename=')[1]
        .replace(/"/g, '')
    }

    // trigger file download
    const blob = new Blob([response.data], { type: response.data.type })
    const fileName = `${downloadName}`
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // IE11
      window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  } catch (error) {
    // console.error('Download failed:', error)
    if (error.response) {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Unexpected error occurred. Kindly contact administrator'}</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      } else {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred. Kindly contact administrator</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      }
    // optionally: show a toast to the user
  } finally {
    loadingDownload.value = false
  }
}

// const downloadWarrant = async () => {
//   const token = Cookies.get('auth_token')

//   // build payload exactly as your spec
//   const payload = {
//     id: id,
//     originatingMda: form.originatingMda,
//     approvalAuthority: form.approvalAuthority,
//     natureOfExpenditure: form.natureOfExpenditure,
//     amountApproved: parseFloat(form.amountApproved),
//     purposeOfRequest: form.purposeOfRequest,
//     approvedBudgetAmount: parseFloat(form.approvedBudgetAmount),
//     amtReleasedToDate: parseFloat(form.amtReleasedToDate),
//     balance: parseFloat(form.balance),
//     performance: parseFloat(form.performance),
//     appraisalEconomicItems: economicItems.value.map(item => ({
//       mdaLineItemBudgetId: item.mdaLineItemBudgetId,
//       amountBudgeted: parseFloat(item.amountBudgeted),
//       amountReleased: parseFloat(item.amountReleased),
//       balance: parseFloat(item.balance),
//       amountRequired: parseFloat(item.amountRequired),
//       year: item.year,
//       quarter: item.quarter,
//       ecoCode: item.ecoCode,
//       title: item.title,
//     })),
//     quarter: parseInt(form.quarter, 10),
//     budgetYear: parseInt(form.budgetYear, 10),
//     appraisalInitiatedDate: form.appraisalInitiatedDate,
//     noOfAppLimitPerQtr: parseInt(form.noOfAppLimitPerQtr, 10),
//     noOfAuthIssuedInQtr: parseInt(form.noOfAuthIssuedInQtr, 10),
//     noOfAuthLeftInQtr: parseInt(form.noOfAuthLeftInQtr, 10),
//     qtrAuthLimitAmt: parseFloat(form.qtrAuthLimitAmt),
//     approvedRecurrentAmount: parseFloat(form.approvedRecurrentAmount),
//     approvedCapitalAmount: parseFloat(form.approvedCapitalAmount),
//     approvalBalance: parseFloat(form.approvalBalance),
//     evalRemarks: form.evalRemarks,
//     amtRecommended: parseFloat(form.amtRecommended),
//     sectoralHeadRemarks: form.sectoralHeadRemarks,
//     dobRemarks: form.dobRemarks,
//     commissionerRemarks: form.commissionerRemarks,
//     orgCode: form.orgCode,
//     psremarks: form.psremarks
//   }

//   try {
//     const response = await axios.post(
//       `${root_api_url}/appraisal/warrant/pdf`,   // <-- your download endpoint
//       payload,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         responseType: 'blob'     // important for binary/pdf
//       }
//     )

//     // trigger file download
//     const blob = new Blob([response.data], { type: response.data.type })
//     const fileName = `warrant_${form.id}.pdf`
//     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
//       // IE11
//       window.navigator.msSaveOrOpenBlob(blob, fileName)
//     } else {
//       const url = window.URL.createObjectURL(blob)
//       const link = document.createElement('a')
//       link.href = url
//       link.setAttribute('download', fileName)
//       document.body.appendChild(link)
//       link.click()
//       document.body.removeChild(link)
//       window.URL.revokeObjectURL(url)
//     }
//   } catch (err) {
//     console.error('Download failed:', err)
//     // optionally: show a toast to the user
//   }
// }






const handleNext = async () => {
  if (step.value < totalSteps) step.value++
}

const recallAppraisal = async () => {
  const confirm = await Swal.fire({
    title: 'Recall Appraisal',
    text: 'Are you sure you want to recall this appraisal?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Recall',
    cancelButtonText: 'Cancel',
  })

  if (!confirm.isConfirmed) return

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`
  const token = Cookies.get('auth_token')

  const recallDto = { id }

  loadingRecall.value = true

  try {
    const { data } = await axios.put(`${root_api_url}/appraisal/appraisal/recall/${id}`, recallDto, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })

    if (data?.errorMessage) {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${data.errorMessage}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      })
      return
    }

    Swal.fire({
      html: `${iconHtmlSuccess}
      <h1 style="font-weight:600;">Success</h1>
      <p>Appraisal recalled successfully.</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    })

    await fetchAppraisal()
  } catch (err) {
    console.error('Failed to recall appraisal:', err)
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>${err?.response?.data?.errorMessage || err?.response?.data?.error || 'Failed to recall appraisal. Please try again.'}</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    })
  } finally {
    loadingRecall.value = false
  }
}

onMounted(() => {
  fetchAppraisal(),
  document.title = "View Appraisal"

  if (userStore.profile?.role) {
    rolesLoaded.value = true
  } else {
    const stop = watch(
      () => userStore.profile?.role,
      (val) => {
        if (val) {
          rolesLoaded.value = true
          stop()
        }
      },
      { immediate: true }
    )
  }
})

</script>

<style scoped>
.loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: all;
  min-height: 300px;
}

.col-md-5 {
  width: 35% !important
}

.form-view-only-input {
    background-color: transparent;
    cursor: default;
    pointer-events: none;
    color: #212529;
    font-size: 1rem;
}

.view-only-input {
  border: none !important;
  background-color: transparent;
  padding-left: 0;
  cursor: default;
  pointer-events: none;
  color: #212529;
  font-size: 1rem;
}

.dashboard-layout .budget-item-wrapper {
  margin-top: 20px;
  padding: 0 20px;
}

.dashboard-layout .budget-item-wrapper .col {
  border: 1px solid #212529;
}

/* .dashboard-layout .budget-item-wrapper.step-3 {
  margin-top: 3px !important;
} */


.dashboard-layout .budget-item-wrapper.step-3 .fixed-label {
  display: flex;
  align-items: center;
  /* vertical center */
  justify-content: center;
  /* horizontal center */
  min-height: 80px;
  width: 100%;
  padding: 0 0.25rem;
  box-sizing: border-box;
  text-align: center;
  /* ensure text is centered if it wraps */
  border-bottom: 1px solid #000;
}

.dashboard-layout .budget-item-wrapper.step-3 .col {
  padding: 0;
}

.dashboard-layout .budget-item-wrapper.step-3 label {
  font-size: 16px;
  padding: .375rem 0 !important;
  margin-bottom: 0px !important;
}

.dashboard-layout .budget-item-wrapper .col-md-5 {
  border: 1px solid #212529;
}

.dashboard-layout .budget-item-wrapper .col-md-5.no-border {
  border: none;

}

.dashboard-layout .budget-item-wrapper .col-md-5.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border {
  border: none;

}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .fixed-label {
  display: flex;
  align-items: center;
  /* vertical center */
  justify-content: center;
  /* horizontal center */
  min-height: 4rem;
  width: 100%;
  padding: 0 0.25rem;
  box-sizing: border-box;
  text-align: center;
  /* ensure text is centered if it wraps */
}

.table-bordered.appraisal-view th {
  font-size: 14px;
}

.table-bordered.appraisal-view thead {
  background: none;
}

.table-bordered.appraisal-view thead th {
  border: 1px solid black;
  background: none;
  /* Optional, in case inherited styles override */
}

.table-bordered.appraisal-view tbody {
  background: none;
}

.table-bordered.appraisal-view tbody td {
  border: 1px solid black;
  background: none;
  /* Optional, in case inherited styles override */
}

.warrant-download-btn-wrapper .btn {
  border-radius: 0px;
  padding: 10px;
  width: auto;
}

.memo-preview-overlay {
  position: fixed;
  inset: 0;
  z-index: 1060;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.memo-preview-modal {
  width: min(920px, 100%);
  max-height: 90vh;
  overflow: hidden;
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.memo-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.memo-preview-body {
  padding: 1rem;
  overflow: auto;
}

.preview-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.6rem;
}

.preview-item {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 0.6rem 0.75rem;
}

.preview-item small {
  color: #6b7280;
  font-size: 0.75rem;
}

.preview-item p {
  color: var(--color);
  font-weight: 600;
}

@keyframes memoSkeletonShimmer {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

.memo-skeleton-bar {
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(90deg, #eceff1 25%, #f5f6f7 37%, #eceff1 63%);
  background-size: 400% 100%;
  animation: memoSkeletonShimmer 1.4s ease infinite;
}

@media (max-width: 576px) {
  .preview-grid {
    grid-template-columns: 1fr;
  }
}
</style>
